import {Dispatch} from 'react'

import {CurrentlyDisplayedPage} from '../../types'
import {FetchVenuesResponse as Address} from '../../services'

export default function Stepper({
  currentlyDisplayedPage,
  setCurrentlyDisplayedPage,
  chosenLocation,
}: {
  currentlyDisplayedPage: CurrentlyDisplayedPage
  setCurrentlyDisplayedPage: Dispatch<CurrentlyDisplayedPage>
  chosenLocation: Address | null
}) {
  return (
    <ol className="flex items-center justify-content text-xs text-gray-500 dark:text-slate-400 font-medium justify-center">
      <li
        className={`flex items-center text-sky-600 ${currentlyDisplayedPage === CurrentlyDisplayedPage.EnterQuantities && 'hover:cursor-pointer'}`}
        onClick={() => {
          if (currentlyDisplayedPage === CurrentlyDisplayedPage.ChooseLocation) {
            return
          }
          setCurrentlyDisplayedPage(CurrentlyDisplayedPage.ChooseLocation)
        }}
      >
        <div
          className={`flex items-center whitespace-nowrap after:content-['>'] after:mx-2 ${currentlyDisplayedPage === CurrentlyDisplayedPage.ChooseLocation ? 'after:text-gray-500 dark:after:text-slate-400' : 'after:text-sky-600 dark:after:text-sky-400'}`}
        >
          <span className="w-6 h-6 bg-sky-600 dark:bg-sky-500 border border-sky-200 dark:border-sky-700 rounded-full flex justify-center items-center mr-3 text-xs text-white">
            {currentlyDisplayedPage === CurrentlyDisplayedPage.ChooseLocation ? '1' : '✓'}
          </span>{' '}
          Choose Location
        </div>
      </li>
      <li
        className={`flex items-center ${currentlyDisplayedPage === CurrentlyDisplayedPage.ChooseLocation ? 'text-gray-600 dark:text-slate-300' : 'text-sky-600 dark:text-sky-400'} ${currentlyDisplayedPage === CurrentlyDisplayedPage.ChooseLocation && chosenLocation !== null && 'hover:cursor-pointer'}`}
        onClick={() => {
          if (
            currentlyDisplayedPage === CurrentlyDisplayedPage.EnterQuantities ||
            chosenLocation === null
          ) {
            return
          }
          setCurrentlyDisplayedPage(CurrentlyDisplayedPage.EnterQuantities)
        }}
      >
        <div className="flex items-center">
          <span
            className={`w-6 h-6 border rounded-full flex justify-center items-center mr-3 ${currentlyDisplayedPage === CurrentlyDisplayedPage.ChooseLocation ? 'bg-gray-100 dark:bg-slate-800 border-gray-200 dark:border-slate-600' : 'bg-sky-600 dark:bg-sky-500 border border-sky-200 dark:border-sky-700 text-white'}`}
          >
            2
          </span>{' '}
          Enter Quantities
        </div>
      </li>
    </ol>
  )
}
